import { Typography } from '@mui/material';
import { useModal } from '../../context/ModalProvider/useModal';
import { Info } from '@mui/icons-material';
import { UploadRequiredDocument } from './UploadRequiredDocument';

type Props = {
  handleRequiredDocumentDelete?: (requiredDocumentId: string) => void;
  handleRequiredDocumentUpload?: (requiredDocumentName: string) => void;
};

export const useStrategyModals = ({
  handleRequiredDocumentUpload,
  handleRequiredDocumentDelete,
}: Props) => {
  const { openModal, closeModal } = useModal();

  const uploadRequiredDocument = (value: string) => {
    if (!!value) {
      handleRequiredDocumentUpload!(value);
      closeModal();
    }
  };

  const deleteRequiredDocument = (requiredDocId: string) => {
    handleRequiredDocumentDelete!(requiredDocId);
    closeModal();
  };

  const openUploadModal = () => {
    openModal({
      title: 'Require a document',
      body: <UploadRequiredDocument />,
      onSubmit: uploadRequiredDocument,
    });
  };

  const openRequiredDocumentDeleteModal = (requiredDocId: string) => {
    openModal({
      icon: <Info sx={{ width: '50px', height: '50px' }} />,
      title: 'Are you sure you want to delete this document?',
      body: (
        <Typography>
          Deleting it will remove this document from the strategy list.
        </Typography>
      ),
      onSubmit: () => deleteRequiredDocument(requiredDocId),
    });
  };

  return { openUploadModal, openRequiredDocumentDeleteModal };
};
